var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top",style:({fontSize: _vm.details.titleSize ? _vm.details.titleSize : '18px'})},[_vm._v(" 中国人民解放军海军博物馆发展历程 ")]),_c('div',{staticClass:"main",domProps:{"innerHTML":_vm._s(_vm.details.txt)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }